module.exports = __webpack_public_path__ + "img/people-40-min.36dd1dd8.png";